<micro-lookup domain="domain" obj="regions" url="/regions" [key]="regionId" [link]="link"></micro-lookup>
